<template>
  <v-dialog :model-value="modelValue" persistent max-width="600">
    <v-card>
      <v-card-title>
        <h3 class="text-h6">Link Items to Subtasks</h3>
      </v-card-title>

      <v-card-text>
        <MatchedItemsProgressBar
          :linked-count="linkedCount"
          :multiple-matches-count="0"
          :matched-count="matchedCount"
          :total-subtasks="totalSubtasks"
        />
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          variant="text"
          :disabled="isProcessing"
          @click="$emit('update:model-value', false)"
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          variant="flat"
          :disabled="isProcessing"
          :loading="isProcessing"
          @click="handleConfirm"
        >
          Confirm
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref } from 'vue';
import MatchedItemsProgressBar from '@/components/charts/MatchedItemsProgressBar.vue';

defineProps({
  modelValue: {
    type: Boolean,
    required: true
  },
  linkedCount: {
    type: Number,
    default: 0
  },
  matchedCount: {
    type: Number,
    default: 0
  },
  totalSubtasks: {
    type: Number,
    default: 0
  }
});

const emit = defineEmits(['update:model-value', 'confirm']);

const isProcessing = ref(false);

const handleConfirm = () => {
  isProcessing.value = true;
  emit('confirm');
};

const setProcessing = (value) => {
  isProcessing.value = value;
};

defineExpose({
  setProcessing
});
</script>
